import { createContext } from 'react';
export const HSAnalyticsContext = /*#__PURE__*/createContext({
  initialPageLoad: false,
  setInitialPageLoad: () => {}
});